<template>
  <div>
    <div class="notAllowedToPrint">
      <span>You are not allowed to print the contents of this page</span>
    </div>
    <div class="page-container" >
      <span v-show="criticalError" class="main-error help is-danger">
        <div class="fal fa-exclamation-circle"></div>
        {{criticalError}}
      </span>
      <loading
        v-if="!criticalError && (loading || greyLabelingLoading)"
        :text="loadingText"
        class="main-loading"
      />
      <slot v-else-if="!loading && !greyLabelingLoading && !criticalError">
        <div>
          <nav
            v-if="$router.currentRoute.path !== '/' && $router.currentRoute.path !== '/logout'"
            :class="headerFontBlack ? 'blackFont' : 'whiteFont'"
            class="navbar is-fixed-top"
            role="navigation"
            aria-label="main navigation"
            :style="{backgroundColor: headerBarColor, 'z-index': '600'}"
          >
            <div class="navbar-brand">
              <div @click="$router.replace('/library')" class="navbar-item-logo">
                <img :src="logo" />
                <span class="navbar-title">miEbooks
                  <span class="version">{{version}}</span>
                </span>                
              </div>
                <span class="sync-for-small logged-in-as" style="display:none">
                  <span v-if="syncingContent" class="syncing-content">
                    <span class="syncing-content-text">Syncing content</span>  <loading small="true"/> 
                  </span>
                </span>
              <a
                role="button"
                :class="headerFontBlack ? 'blackFont' : 'whiteFont'"
                class="navbar-burger burger"
                aria-label="menu"
                aria-expanded="false"
                data-target="navbarItems"
                @click="showMenu = !showMenu"
              >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </a>
            </div>
            <div id="navbarItems" class="navbar-menu" v-bind:class="{'is-active': showMenu}">
              <div class="navbar-start" v-if="userLoggedIn">
                <slot v-for="(menuItem, i) in menuItems">
                  <slot v-if="menuItem.active">   
                    <div
                      v-if="menuItem.children"
                      v-bind:key="'mainMenuItem' + i"
                      class="navbar-item has-dropdown is-hoverable"
                    >
                      <a class="navbar-link hide-for-small">
                        <span class="icon" v-if="menuItem.icon">
                          <i :class="'fal fa-' + menuItem.icon"></i>
                        </span>
                        {{menuItem.name}}
                      </a>

                      <hr class="small-divider" v-if="i !== 0"/>

                      <div class="navbar-dropdown" style="z-index: 601 !important">
                        <slot v-for="(subMenuItem, j) in menuItem.children">
                          <slot v-if="subMenuItem.active">
                            <a
                              v-if="subMenuItem.linkExternal"
                              v-bind:key="'mainMenuItem' + i + '-' + j"
                              class="navbar-item"
                              :href="subMenuItem.link"
                              target="_blank"
                              @click="if(subMenuItem.callback) subMenuItem.callback()"
                            >
                              <span class="icon" v-if="subMenuItem.icon">
                                <i :class="'fal fa-' + subMenuItem.icon"></i>
                              </span>
                              {{subMenuItem.name}}
                            </a>

                            <hr
                              class="navbar-divider"
                              v-else-if="subMenuItem.isDivider"
                              v-bind:key="'mainMenuItem' + i + '-' + j"
                            />

                            <router-link
                              v-else
                              :to="subMenuItem.link"
                              v-bind:key="'mainMenuItem' + i + '-' + j"
                              class="navbar-item"
                            >
                              <span class="icon" v-if="subMenuItem.icon">
                                <i :class="'fal fa-' + subMenuItem.icon"></i>
                              </span>
                              {{subMenuItem.name}}
                            </router-link>
                          </slot>
                        </slot>
                      </div>
                    </div>
                    <a
                      v-if="menuItem.linkExternal && menuItem.link"
                      v-bind:key="'mainMenuItem' + i"
                      class="navbar-item"
                      :href="menuItem.link"
                      target="_blank"
                      @click="if(menuItem.callback) menuItem.callback()"
                    >
                      <span class="icon" v-if="menuItem.icon">
                        <i :class="'fal fa-' + menuItem.icon"></i>
                      </span>
                      {{menuItem.name}}
                    </a>
                    <router-link 
                      v-else-if="menuItem.link" :to="menuItem.link" 
                      v-bind:key="'mainMenuItem' + i" 
                      class="navbar-item"
                    >
                      <span class="icon" v-if="menuItem.icon">
                        <i :class="'fal fa-' + menuItem.icon"></i>
                      </span>
                      {{menuItem.name}}
                    </router-link>
                  </slot>
                </slot>
              </div>

              <!-- <div class="navbar-end" v-if="userLoggedIn">
              <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link">
                  Switch Users
                </a>

                <div class="navbar-dropdown">
                  <a class="navbar-item" href="https://www.itsieducation.com/blog/tag/parent/?utm_source=Parent%20App&utm_medium=App&utm_campaign=PArent%20Blogs" target="_blank">
                    John
                  </a>
                  <a class="navbar-item" href="https://www.itsieducation.com/blog/tag/parent/?utm_source=Parent%20App&utm_medium=App&utm_campaign=PArent%20Blogs" target="_blank">
                    Sarah
                  </a>
                  <hr class="navbar-divider">
                  <a class="navbar-item" target="_blank">
                    Manage Users
                  </a>
                  <hr class="navbar-divider">
                  <a class="navbar-item" target="_blank">
                    Logout
                  </a>
                </div>
              </div>
              </div>-->
              <div class="navbar-end" v-if="userLoggedIn">
                <span class="hide-for-small logged-in-as">
                  <span v-if="syncingContent" class="syncing-content">
                    <loading small="true"/> <span class="syncing-content-text">Syncing content</span>
                  </span>
                  <span v-else>
                    Logged in as: {{username}}
                  </span>
                </span>
                <div class="navbar-item">
                  <a class="button is-primary" @click="logout()">
                    <strong>Log out</strong>
                  </a>
                </div>
              </div>
              <div v-else class="navbar-end">
                <div class="navbar-item">
                  <div class="navbar-buttons">
                    <!-- <router-link to="/register" class="button is-primary">
                    <strong>Sign up</strong>
                    </router-link>-->
                    <!-- <router-link to="/login" class="button is-light">
                    Log in
                    </router-link>-->
                  </div>
                </div>
              </div>
            </div>
          </nav>
          <div id="myModal" class="modal">
            <div class="modal-content">
              <div v-if="!sessionMessage" @click="closeSessionModal()" class="close topright">&times;</div>
              <span v-if="sessionMessage" class="modal-text">Your session have expired. You will be automatically logged out in <b>{{logoutSeconds}}</b>...</span>
              <span v-else class="modal-text">Your session will expire soon.</span>
              <div class="modal-buttons">
                <a class="button is-primary" @click="login()">
                  <strong>Stay Logged in</strong>
                </a>
                <a class="button is-pulled-right" @click="logout()">
                  <strong>Log out</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div :style="$router.currentRoute.path === '/' ? '' : 'padding-top: 64px'">
          <ResourceView v-if="$route.query.res" />
          <router-view v-if="!loading" v-show="!$route.query.res" />
        </div>
      </slot>
    </div>
    <Notification v-if="appError" :message="appError" type="error" @closed="appError = ''" />
  </div>
</template>

<script>
import utils from "@/utils/utils.js";
import userUtils from "@/utils/userUtils.js";
import routes from "@/router/routes.js";
import error from "@/utils/error.js";
import indexedDBUtils from "@/utils/indexedDBUtils";
import analytics from "@/utils/analytics.js";
import websockets from "@/utils/websockets.js";
import storeHelpers from "@/utils/storeHelpers.js";
import Vue from "vue";
import ResourceView from "./components/resource/ResourceView";
import Notification from "./components/notifications/Notification";

const JSZip = require("jszip");
const JSZipUtils = require("jszip-utils");
const moment = require("moment");
require("moment-timezone");
moment.tz.setDefault("Africa/Johannesburg");

var protobuf = require("protobufjs");

import version from "../version.json";

export default {
  name: "app",
  components: {
    ResourceView,
    Notification
  },
  data: function() {
    return {
      version: version.version,
      year: "YYYY",
      showMenu: false,
      menuItems: [],
      utils,
      userUtils,
      loading: true,
      greyLabelingLoading: true,
      criticalError: "",
      appError: "",
      headerBarColor: "rgb(35, 104, 197)",
      headerFontBlack: false,
      logo: "",
      inFocus: true,
      swRegistration: {},
      loadingText: "Getting it ready for you. Please wait...",
      initialContentLoaded: false,
      indexedDBInstance: undefined,
      hasNewsletter: false,
      unwatchFunction: undefined,
      syncingContent: false,
      activeElement: undefined,
      currentTime: 0,
      checkingCookieTimeout: false,
      popupClosed: false,
      logoutSeconds: 5,
      sessionMessage: false,
      logoutTimerStart: false,
      userLoggedIn: false,
      username: this.$store.state.user.username
    };
  },
  created() {
    var t = this;
    
    // Push notifcations
    t.onpush = function(event) {
      utils.log(t, event.data);
      // From here we can write the data to IndexedDB, send it to any open
      // windows, display a notification, etc.
    };

    // utils.log(t, "navigator:", navigator);

    // if ("serviceWorker" in navigator) {
    //   utils.log(t, "serviceWorker")
    //   if (navigator.serviceWorker.controller) {
    //     utils.log(t, "[PWA Builder] active service worker found, no need to register");
    //     navigator.serviceWorker.getRegistration().then(function(reg) {
    //       t.swRegistration = reg;
    //     });
    //   } else {
    //     utils.log(t, "[PWA Builder] active service worker not found, need to register");
    //     // Register the service worker
    //     navigator.serviceWorker
    //     .register(t.$config.get("basePathFiles") + "static/scripts/pwabuilder-sw.js", {scope: "./"})
    //     .then(function(reg) {
    //       t.swRegistration = reg;
    //       utils.log(t, "[PWA Builder] Service worker has been registered for scope: " + reg.scope);
    //     });
    //   }
    // }
  },
  beforeMount() { 
    window.addEventListener("beforeunload", event => {
      if (!Object.keys(this.$store.state.contentToSync).length > 0) return
      event.preventDefault()
      event.returnValue = ""
    })
  },
  mounted: async function() {
    var t = this;
    t.year = moment().format("YYYY");

    this.unwatchFunction = utils.watchStoreProperty(this, 'contentToSyncCounter', this.syncContentUpdated);

    // log out
    if (t.$router.currentRoute.path === "/logout") {
      t.loading = false;
      t.greyLabelingLoading = false;
      return;
    }

    this.userLoggedIn = userUtils.isLoggedIn(this.$store)

    if (this.userLoggedIn) {
      if (t.$store.state.user.tempPassword) {
        // storeHelpers.setAnalytics(t, false)
      }
      await this.checkNewsletter();
      protobuf.load(
        t.$config.get("basePathFiles") + "static/protos/appdata.proto",
        function(err, appDataProtos) {
          window.appDataProtobuf = appDataProtos;
          protobuf.load(
            t.$config.get("basePathFiles") + "static/protos/device_events.proto",
            function(err, deviceEventProtos) {
              if (err) throw err;
              t.logo = t.$config.get("basePathFiles") + "static/img/logo.png";
              window.deviceEventsProtobuf = deviceEventProtos;
              indexedDBUtils.openDb(function(indexedDBInstance) {
                t.indexedDBInstance = indexedDBInstance;
                if(!t.initialContentLoaded) {
                  indexedDBUtils.getState(t.indexedDBInstance, function(state) {
                    if(state && state.deviceFeatures && state.bookList && state.netch && state.pagesOpened) {
                      t.onDeviceFeaturesReceived(state.deviceFeatures);
                      t.$store.commit("restoreContentFromIndexedDB", state);
                      t.loading = false;
                      t.createCookieTimer();
                    } else {
                      if (storeHelpers.getLoginTime(t) === 0) {
                        storeHelpers.setLoginTime(t)
                        t.createCookieTimer();
                      }
                    }
                  });
                }
              });
              // console.log("state:", t.$store.state)
              t.refreshFetchTimer();
              t.refreshSyncTimer();
              websockets.setupWebsocket(t, "analytics");
              if (storeHelpers.getAnalytics(t)) {
                analytics.started(t, window.deviceEventsProtobuf); 
                protobuf.load(
                  t.$config.get("basePathFiles") + "static/protos/general_types.proto",
                  function(err, generalTypeEventProtos) {
                    if (err) throw err
                    window.generalTypeEventsProtobuf = generalTypeEventProtos;
                    analytics.info(t, window.generalTypeEventsProtobuf);
                  }
                );          
              }
            });
        });
        setInterval(t.checkFocus, 700);
    } else {
      utils.log(t, "Not logged in");
      t.loading = false;
      t.getDeviceFeatures();
      t.checkPathForAuth();
    }    
  },
  destroyed() {
    this.unwatchFunction();
  },
  watch: {
    $route: function(to, from) {
      this.checkPathForAuth();

      this.showMenu = false;
    },
    currentTime: function(cTime) {
      var t = this;
      var expireTime = storeHelpers.getCookieExpireTime(t);
      var timeLeft = expireTime - cTime;
      // utils.log(t,"check:", timeLeft);
      if (timeLeft <= 900000 && timeLeft >= 600000) { // 45 - 50 minute mark
      // if (timeLeft <= 45000 && timeLeft >= 10000) { // 45 - 50 seconds mark - test
        // check API list
        storeHelpers.setCheckActive(t, true);
        var isActive = storeHelpers.getActive(t);
        if (isActive) {
          t.login();
        }
      } else if (timeLeft < 600000 && timeLeft >= 5000) { // 50 - 59 minutes and 55 seconds mark
      // } else if (timeLeft < 10000 && timeLeft >= 5000) { // 50 - 55 seconds mark - test
        // show popup
        t.sessionMessage = false;
        if (!t.popupClosed) {
          document.getElementById("myModal").style.display = "block";
          storeHelpers.setCheckActive(t, false);
        }
      } else if (timeLeft < 5000) {
        // logout
        t.sessionMessage = true;
        document.getElementById("myModal").style.display = "block";
        storeHelpers.setCheckActive(t, false);
        t.checkingCookieTimeout = false;
        if (!t.logoutTimerStart) {
          t.logoutTimerStart = true;
          t.startLogoutTimer();
        }
      }
    }
  },
  methods: {
    createCookieTimer: function() {
      var t = this;
      var eTime = storeHelpers.getCookieExpireTime(t);
      this.popupClosed = false;
      if (eTime !== 0) {
        var timeLeft = storeHelpers.getExpireTimeDifference(t, Date.now());
        utils.log(t, "timeLeft:", timeLeft)
        if (timeLeft >= -900000) {
        // if (timeLeft >= -15000) {
          setTimeout(() => {
            // start the checking
            t.checkingCookieTimeout = true;
            t.checkCookie(Date.now())
          // }, 2700000); // 45 minutes
          }, timeLeft); // 45 seconds - test
        }
      }
    },
    checkCookie: function(cTime) {
      var t = this;
      if (t.checkingCookieTimeout) {
        setTimeout(() => {
          t.currentTime = cTime;
          t.checkCookie(Date.now());
        }, 1000); // check every second
      } else {
        t.createCookieTimer();
      }
      return;
    },
    startLogoutTimer: function() {
      var t = this;
      if (t.logoutSeconds >= 0) {
        setTimeout(() => {
          t.logoutSeconds -= 1;
          t.startLogoutTimer();
        }, 1000);
      } else {
        document.getElementById("myModal").style.display = "none";
        t.logout();
        return;
      }
    },
    refreshFetchTimer: function() {
      if(utils.hasInternetConnection()) {
        userUtils.checkAuth(this, this.fetchContent);
      }
      setTimeout(this.refreshFetchTimer, 60 * 7000); // 7 minutes - 1 minute for test // todo
    },
    refreshSyncTimer: function() {
      if(utils.hasInternetConnection()) {
        userUtils.checkAuth(this, this.syncContent);
      }

      setTimeout(this.refreshSyncTimer, 10 * 1000); // 10 seconds
    },
    logout: function() {
      this.$router.push('/logout');
    },
    leaving: function(event) {
      
    },
    checkPathForAuth() {
      const currentPath = this.$router.currentRoute.path;
      const allRoutes = (utils.isParentApp() ? routes.parentRoutes : routes.defaultRoutes);

      // utils.log(this, "Checking auth for path:", currentPath);

      const definedRoute = _.find(allRoutes, route => route.path === currentPath);
      if(definedRoute && !definedRoute.disableAuth) {
        utils.log(this, "Requires auth");
        userUtils.checkAuth(this);
      } 
    },
    setupMenu: function(deviceFeatures) {
      var t = this;

      var allMenuItems = [
        {
          name: "My Content",
          icon: "books",
          children: [
            {
              name: "Library",
              id: "aefdd21b-6847-4c0a-bd95-e9294374b1fb",
              icon: "book",
              link: "/library",
              linkExternal: false
            },
            {
              name: "Groups",
              id: "041fef2f-90d2-448b-ac74-dad28e955612",
              icon: "users-class",
              link: "/groups",
              linkExternal: false
            },
            {
              name: "Book Resources",
              id: "50513c13-f7bb-4a76-aa62-775579d3bb66",
              icon: "paperclip",
              link: "/book-resources/all",
              linkExternal: false
            },
            {
              name: "My Folders",
              icon: "folder-open",
              id: "47f764bc-773d-456e-81e8-5ee5191c2e01",
              link: "/folders/myfolders",
              linkExternal: false
            },
            {
              name: "Learning Tools",
              id: "dc81a843-9811-43c8-b1a8-0dd3e9db80c7",
              icon: "lightbulb",
              link: "/learning-tools",
              linkExternal: false
            }
          ]
        },
        {
          name: "My Activity",
          icon: "history",
          children: [
            {
              name: "Analytics",
              icon: "chart-bar",
              link: "/analytics",
              id: "785c1db1-9e58-47d8-b7d2-b9f39a0473c4",
              linkExternal: false
            },
            {
              name: "miEbooks Feed",
              icon: "list-alt",
              link: "/feed",
              id: "785c1db1-9e58-47d8-b7d2-b9f39a0473c4",
              linkExternal: false
            }
          ]
        },
        {
          name: "More",
          children: [
            {
              name: "Newsletter",
              link: this.$config.get("dns") + "/educator/newsletter",
              id: "a3b1208c-32b0-429b-b6c5-86e1f3766b61",
              linkExternal: true,
              callback: function() {
                if (storeHelpers.getAnalytics(t))
                  analytics.newsletter(this, window.deviceEventsProtobuf);
              }
            },
            {
              name: "Calendar",
              link: "/calendar",
              id: "7ab44e54-808e-4bd6-a17f-5c214c1c8377",
              linkExternal: false
            },
            {
              isDivider: true
            },
            {
              name: "Digital Parent",
              link:
                "https://www.itsieducation.com/blog/tag/parent/?utm_source=Parent%20App&utm_medium=App&utm_campaign=PArent%20Blogs",
              linkExternal: true,
              callback: function() {
                if (storeHelpers.getAnalytics(t))
                  analytics.externalURLOpen(t, this.link, 1);                
              }
            },
            {
              name: "About Us",
              link: "https://www.itsieducation.com/about/",
              linkExternal: true,
              callback: function() {
                if (storeHelpers.getAnalytics(t))
                  analytics.externalURLOpen(t, this.link, 1);
              }
            },
            {
              name: "Contact Us",
              link: "https://www.itsieducation.com/contact",
              linkExternal: true,
              callback: function() {
                if (storeHelpers.getAnalytics(t))
                 analytics.externalURLOpen(t, this.link, 1);
              }
            },
            {
              isDivider: true
            },
            {
              name: "Report an Issue",
              link: this.$config.get("localServerOrAppDev")
                ? "/issue"
                : "https://www.itsieducation.com/contact",
              linkExternal: !this.$config.get("localServerOrAppDev")
            }
          ]
        }
      ];

      // Update menu titles based on customisation
      _.each(allMenuItems, function(menuItem) {
        Vue.set(menuItem, "active", true);
        
        _.each(menuItem.children, function(childItem) {
          Vue.set(childItem, "active", true);
          childItem.name = utils.getNavName(childItem.id, t, true, childItem.name, deviceFeatures);
        });
      });

      // parent app 
      if(utils.isParentApp()) {
        window.document.title = "miEbooks for Parents";

        var newsletterItem = this.findNavItem("Newsletter", allMenuItems);
        newsletterItem.icon = "newspaper";
        newsletterItem.active = this.hasNewsletter;

        var calendarItem = this.findNavItem("Calendar", allMenuItems);
        calendarItem.icon = "calendar";
        
        this.menuItems = [
          this.findNavItem("miEbooks Feed", allMenuItems),
          this.findNavItem("Analytics", allMenuItems),
          calendarItem,
          newsletterItem
        ]
      } else {
        window.document.title = "miEbooks for Web";
        
        // Filter out inactive children nav items
        _.each(allMenuItems, function(menuItem) {
          menuItem.children = _.each(menuItem.children, function(childItem) {
            childItem.active = !childItem.id || utils.isNavItemActive(childItem.id, deviceFeatures);

            // disable newsletter if HEAD request failed
            if(childItem.name === "Newsletter" && !t.hasNewsletter) {
              childItem.active = false;
            }
          });
        });

        // Filter out parent nav items if all children are filtered out
        this.menuItems = _.filter(allMenuItems, function(menuItem) {
          return (
            !menuItem.children ||
            _.filter(menuItem.children, function(child) {
              return child.active;
            }).length > 0
          );
        });
      }
    },
    findNavItem(name, allMenuItems) {
      var item = undefined;
      _.each(allMenuItems, function(menuItem) {
        if(menuItem.name === name) {
          item = menuItem;
          return false;
        }

        _.each(menuItem.children, function(childItem) {
          if(childItem.name === name) {
            item = childItem;
            return false;
          }
        });
      });

      return item;
    },
    onDeviceFeaturesReceived: function(data) {
      this.$store.commit("updateDeviceFeatures", data);
      this.setupMenu(data);

      if (data && data["grey-label"] && data["grey-label"].enabled) {
        if (
          data["grey-label"]["header-bar-colour"] &&
          data["grey-label"]["header-bar-colour"].length > 0
        ) {
          this.headerBarColor = data["grey-label"]["header-bar-colour"];
        }
        this.headerFontBlack = utils.shouldTextBeBlack(
          data["grey-label"]["header-bar-colour"].replace("#", "")
        );

        this.fetchGreyLabeling(data["grey-label"].assetZipUrl);
      } else {
        this.greyLabelingLoading = false;
      }
    },
    getDeviceFeatures: function() {
      var t = this;
      var url = this.$config.get("ecApi") + "features/devices";

      return axios
        .get(url)
        .then(response => {
          t.onDeviceFeaturesReceived(response.data);
        })
        .catch(e => {
          error.check401And498(t, e);
          t.loading = false;
          t.onAppError(error.logAndGetError(t, e));
        });
    },
    getContentPayload: function(bookList) {
      var t = this;
      var since = storeHelpers.getSince(t);
      var data = {
        bookContent: {},
        lps: {},
        services: {
          since: since
        },
        freeform: {
          since: since
        }
      };

      _.each(bookList, function(book) {
        data.bookContent[book.id] = { since: since };
      });

      // utils.log(this, JSON.stringify(data));

      return data;
    },
    checkToSyncNetch() {
      this.syncNetch("resources", "read_res");
      this.syncNetch("attachments", "read_att");
    },
    syncNetch(resourcesOrAttachments, key) {
      if (this.$store.state.netch.initialized) {
        const dirtyNetch = _.filter(
          this.$store.state[resourcesOrAttachments],
          function(resOrAtt) {
            return resOrAtt.isReadDirty;
          }
        );

        // if nothing to sync, stop
        if (dirtyNetch.length === 0) return;

        const dirtyNetchById = _.map(dirtyNetch, function(resOrAtt) {
          return resOrAtt._id;
        });

        storeHelpers.addItemToSync(this, {
          url: this.$config.get("ecApi") + "netch/" + key,
          method: this.$store.state.netch[resourcesOrAttachments] ? "patch" : "put", // put if netch has never been initialised for this key
          data: {
            value: JSON.stringify(dirtyNetchById)
          }
        });

        // mark isReadDirty to false after sync
        _.each(this.$store.state[resourcesOrAttachments], resOrAtt => {
          if (resOrAtt.isReadDirty) {
            resOrAtt.isReadDirty = false;
          }
        })
      }
    },
    syncContentUpdated: function() {
      const contentToSync = this.$store.state.contentToSync;
      // window.beforeunload = this.leaving();
      this.syncingContent = contentToSync && Object.keys(contentToSync).length;
    },
    syncContent: async function(username) {
      var t = this;

      t.checkToSyncNetch();

      const contentToSync = this.$store.state.contentToSync;

      if (Object.keys(contentToSync).length === 0) return;
      
      Object.keys(contentToSync)
        .sort()
        .forEach(async function(index) {
          const item = contentToSync[index];
          utils.log(t, "Syncing #" + index, item);
          var method = item.method;
          await axios({
            method: method,
            url: item.url,
            data: item.data,
            headers: item.headers
          })
          .then(response => {
            utils.log(t, "Successfully synced");
            t.$store.commit("removeItemToSync", index);
          })
          .catch(e => {
            error.logAndGetError(t, e);
            if (method.toLowerCase() === "delete" && (e.response.status === 410 || e.response.status === 404)) {
              t.$store.commit("removeItemToSync", index);
            }
          });
        });
    },
    fetchContent: async function(username) {
      var t = this;
      var bookList = [];

      t.getDeviceFeatures();

      await t.getServerTime(async result => {
        if(t.checkError(result, true)) return;

        // parent app doesn't need the rest of the content
        if(!utils.isParentApp()) {
          // booklist
          result = await t.fetchData("library", this.$config.get("ecApi") + "users/" + username + "/books", "updateBookList");
          if(t.checkError(result)) return;
          bookList = result.data;

          // netch
          result = await t.fetchData("unread resources", t.$config.get("ecApi") + "netch?id=read_att&id=read_res", "updateNetch");
          if(t.checkError(result)) return;

          // pages opened
          // result = await t.fetchData("book activity", t.$config.get("dns") + "/redstone/api/student/book-page-times", "updatePagesOpened");
          // if(t.checkError(result)) return;

          // unified endpoint
          result = await t.getContent(username, bookList);
          if(t.checkError(result)) return;
        }

        t.initialContentLoaded = true;

        if(t.indexedDBInstance) {
          indexedDBUtils.setState(t.indexedDBInstance, t.$store.state);
        }

        t.loading = false;
      })
    },
    checkError: function(result, isCriticalError) {
      var t = this;
      
      if (result.error) {
        utils.log(t, result.error);
        if(isCriticalError) {
          t.criticalError = result.error;
        } else {
          t.onAppError(result.error);
        }
        t.loading = false;
        return true;
      }

      return false;
    },
    fetchData: async function(whatToSync, url, stateModiferName) {
      var t = this;
      return axios
        .get(url)
        .then(response => {
          t.$store.commit(stateModiferName, response.data);
          return {data: response.data};
        })
        .catch(e => {
          error.check401And498(t, e);
          return {
            error: "Timed out while syncing your " + whatToSync
          };
        });
    },
    getServerTime: async function(callback) {
      var t = this;
      return utils.getServerTime(t, function (time) {

        if (time.error) {
          return callback({error: "Error fetching server time. Please ensure you are connected to the internet and refresh the page."});
        }

        var now = moment();
        var timeDiffSecs = Math.abs(time.diff(now)) / 1000;

        // 10 minutes
        if (timeDiffSecs > 60 * 10) {
          callback({
            error: "Your current time is " + utils.getFormattedDate(now) + ". The server time is " + utils.getFormattedDate(time) + ". We unfortunately have to disable communication between your device and the server due to the time difference of larger than 10 minutes" + ". Please set the system clock to match the server time and refresh the page."
          });
        }
        callback({});
      });
    },
    getContent: async function(username, newBooklist) {
      var t = this;
      var url = t.$config.get("ecApi") + "users/" + utils.uriEncode(username) + "/content";
      var payload = t.getContentPayload(newBooklist)
      return axios
        .post(url, payload)
        .then(response => {
          t.$store.commit("updateContent", response.data);
          return {};
        })
        .catch(e => {
          error.check401And498(t, e);
          console.error("Error:", e)
          return {
            error: error.logAndGetError(t, e) + "while fetching your content."
          };
        });
    },
    fetchGreyLabeling: function(assetZipURL) {
      var t = this;

      var url = this.$config.get("dns") + "/educator" + assetZipURL;

      JSZipUtils.getBinaryContent(url, function(e, data) {
        if (e) {
          t.greyLabelingLoading = false;
          return;
        }

        JSZip.loadAsync(data)
          .then(function(zip) {
            zip
              .file("drawerTop.png")
              .async("base64")
              .then(function(base64) {
                t.logo = "data:image/png;base64, " + base64;
                t.greyLabelingLoading = false;
              });
          })
          .catch(response => {
            t.greyLabelingLoading = false;
          });
      });
    },
    checkNewsletter: async function() {
      var t = this;
      var url = this.$config.get("dns") + "/educator/newsletter";
      return axios
        .head(url)
        .then(response => {
          if (response.status === 200) {
            t.hasNewsletter = true;
          } else {
            t.hasNewsletter = false;
          }
        })
        .catch(error => {
          t.hasNewsletter = false;
        });
    },
    checkFocus() {
      if ( document.hasFocus() ) {
        if (!this.inFocus) {
          analytics.focusGained(this);
          this.inFocus = true;
        }
      } else {
        if (this.inFocus) {
          analytics.focusLost(this);
          this.inFocus = false;
        }
      }
    },
    sendLocalPushMessage: function(message) { // placeholder function for push locations later
      var t = this;
      var options = {
        body: message,
        vibrate: [100, 50, 100],
        data: {
          dateOfArrival: Date.now(),
          primaryKey: "2"
        },
        actions: [{ action: "close", title: "Close", icon: "images/xmark.png" }]
      };
      t.swRegistration.showNotification("miEbooks Notification", options);
    },
    onAppError: function(message) {
      this.appError = message;
      this.clearAppErrorDebounced();
    },
    clearAppErrorDebounced: function() {
      _.debounce(function() {
        this.clearAppError();
      }, this.$config.get('errorMessageClearedAfter') * 1000)
    },
    clearAppError: function() {
      this.appError = "";
    },
    time() {
      return storeHelpers.getCookieExpireTime(this);
    },
    closeSessionModal() {
      document.getElementById("myModal").style.display = "none";
      this.popupClosed = true;
    },
    login() {
      var t = this;
      var url = t.$config.get("ecApi") + "login/session";
      return axios
      .get(url)
      .then(response => {
        userUtils.userAndTokenReceived(response.data, t, ()=>{
          t.checkingCookieTimeout = false;
          storeHelpers.setLoginTime(t);
          storeHelpers.setActive(t, false);
          storeHelpers.setCheckActive(t, false);
          if (t.indexedDBInstance) {
            indexedDBUtils.setState(t.indexedDBInstance, t.$store.state);
          }
          document.getElementById("myModal").style.display = "none";
          t.popupClosed = true;
        })
      })
      .catch(e => {
        t.checkingCookieTimeout = false;
        console.error("could not update session cookie:", e)
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.version {
  color: $version-color;
  display: block;
  font-size: 8pt;
}

.main-error .fal {
  font-size: 34pt;
  display: block;
  padding: 10px;
  margin-bottom: 20px;
}

.main-error {
  max-width: 800px;
  margin: 0 auto;
  padding: 30px;
  font-size: 14pt;
  text-align: center;
}

.main-loading {
  padding-top: 30px;
  display: block;
}

.logged-in-as {
  margin-right: 0px;
  font-size: 10pt;
  margin-top: 23px;
}

.syncing-content {
  vertical-align: top;

  .syncing-content-text {
    margin-top: 1px;
    display: inline-block;
  }

  .small-loading-container {
    vertical-align: top;
    margin-top: -1px;
  }
}

.modal {
  display: none; 
  position: fixed; 
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.6);

  .modal-content {
    background-color: $modal-content-background;
    margin: 200px auto;
    padding: 20px;
    border: 1px solid #888;
    width: 350px;

    .modal-text {
      font-size: 13pt;
    }

    .modal-buttons {
      margin-top: 15px;
    }

  
    .close {
      color: $dark-font-color;
      font-size: 28px;
      font-weight: bold;
      margin-right: 10px
    }

    .topright {
      position: absolute;
      right: 0;
      top: 0
    }

    .close:hover,
    .close:focus {
      color: black;
      text-decoration: none;
      cursor: pointer;
    }
  }
}


</style>
